/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback } from "react";
import "./meeting-sdk.css";
import ZoomMtgEmbedded, { SuspensionViewType } from '@zoom/meetingsdk/embedded';
import MeetingSdkProps from "../../interfaces/meeting-sdk";
import debounce from "lodash.debounce";
import { Modifier, ModifierArguments } from "@popperjs/core";
import { toast } from "react-toastify";

const chatCustomStyle: Modifier<"customStyle", {}> = {
  name: "customStyle",
  enabled: true,
  phase: "write",
  fn: ({ state }: ModifierArguments<{}>) => {
    state.elements.popper.classList.add("chat-style");
  },
};

const chatModifiers = [chatCustomStyle];

const participantsCustomStyle: Modifier<"customStyle", {}> = {
  name: "customStyle",
  enabled: true,
  phase: "write",
  fn: ({ state }: ModifierArguments<{}>) => {
    state.elements.popper.classList.add("participants-style");
  },
};

const participantsModifiers = [participantsCustomStyle];

const MeetingSdkView: React.FC<MeetingSdkProps> = ({
  meetingNumber,
  password,
  userName,
  userEmail,
  zakToken,
  tk,
  signature,
  setLoading,
  getVideoHeight ,
  isSlides
}) => {
  // Debounced version of openChat function
  const openChat = useCallback(
    debounce(async () => {
      const Participants = document.querySelector(
        '[aria-label="Participants"]'
      ) as HTMLElement;
      const Chatpanel = document.querySelector(
        '[aria-label="Chat Small Meeting6"]'
      ) as HTMLElement;

      const qnAPanel = document.querySelector(
        '[aria-label="QA Meeting6"]'
      ) as HTMLElement;

      if (Participants && Chatpanel) {

        Participants.click();
        Chatpanel.click();
        qnAPanel.click();
        setTimeout(async () => {
          await window.scrollTo({ top: 0 });
          setLoading(false);
        }, 0);

      } else {
        console.warn("One or more chat elements not found.");
      }
    }, 300),
    []
  ); // 300 ms debounce delay

  useEffect(() => {
    let isMounted = true;

    const startMeeting = async () => {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const sdkKey = process.env.REACT_APP_SDK_KEY;
      const presenterLoginUrl = `${baseUrl}/login/presenter/${meetingNumber}`;

      const client = ZoomMtgEmbedded.createClient();
      let widthForVideo: any;
      if (window.innerWidth < 1490) {
        widthForVideo = 400;
      } else {
        widthForVideo = 600;
      }

      try {
        const meetingSDKElement = document.getElementById("meetingSDKElement");
        const meetingSDKChatElement = document.getElementById(
          "meetingSDKChatElement"
        );
        const participantElement =
          document.getElementById("participantElement");

        if (!meetingSDKElement || !meetingSDKChatElement) {
          console.error("Meeting SDK elements not found.");
          return;
        }

        await client.init({
          zoomAppRoot: meetingSDKElement,
          language: "en-US",
          customize: {
            video: {
              defaultViewType: 'gallery' as SuspensionViewType,
              popper: {
                disableDraggable: true,
              },
              viewSizes: {
                default: {
                  width: widthForVideo,
                  height: 400,
                },
                ribbon: {
                  width: 600,
                  height: 400,
                },
              },
            },
            chat: {
              popper: {
                disableDraggable: true,
                anchorElement: meetingSDKChatElement,
                modifiers: chatModifiers,
              },
            },
            participants: {
              popper: {
                disableDraggable: true,
                placement: "right-start",
                anchorElement: participantElement,
                modifiers: participantsModifiers,
              },
            },
          },
        });

        if (isMounted) {
          await client
            .join({
              signature,
              sdkKey,
              meetingNumber,
              password,
              userName,
              userEmail,
              tk: tk || "",
              zak: zakToken || "",
            })
            .then(() => {
              document.body.classList.add("speaker-view");
              calculateHeight();
              openChat();
              const hideShareButton = document.querySelector('[aria-label="Share Screen"]');
              if (isSlides) {
                (hideShareButton as HTMLElement).style.display = isSlides ? 'none' : 'block';
              }
              //Listen for meeting end event
              client.on("connection-change", (payload) => {
                if (payload.state === "Closed") {
                  window.location.href = presenterLoginUrl;
                }
              });
            }).catch((error) => {
              if (error.reason == "participant exist") {
                toast.error("You are already in the meeting on another device or tab.", {
                  onClose: () => {
                    window.location.reload();
                  }
                });
              } else {
                toast.error(`Error joining meeting: ${error.reason || error.message}`,
                  {
                    onClose: () => {
                      window.location.href = presenterLoginUrl;
                    },
                  }
                );
              }
            });
        }
      } catch (error) {
        setLoading(false);
        toast.error(`An error occurred while starting the meeting ${error}`);
      }
    };

    startMeeting();

    return () => {
      isMounted = false;
    };
  }, [
    meetingNumber,
    password,
    userName,
    userEmail,
    signature,
    tk,
    zakToken,
    openChat,
    setLoading
  ]);


  const calculateHeight = useCallback(() => {
    let sdkMeetingHeight;
    const parentElement = document.querySelector('.meeting-sdk-element');
    if (parentElement instanceof HTMLElement) {
      // const childElement = parentElement.querySelector('.MuiBox-root.css-12efcmn');
      const childElement = parentElement.querySelector('.react-draggable > div');
      if (childElement instanceof HTMLElement) {
        const childHeight = childElement.offsetHeight;
        sdkMeetingHeight = childHeight;
      } else {
        console.log('Child element with class "one child" not found.');
      }
    } else {
      console.log('Parent element with class "parent" not found.');
    }
    getVideoHeight(sdkMeetingHeight);
  }, []);

  return (
    <div className="meeting-sdk-container">
      <div id="meetingSDKElement" className="meeting-sdk-element"></div>
    </div>
  );
};

export default MeetingSdkView;
